
        const listItems = document.querySelectorAll('.about_timeline_slider li');
        const contentDivs = document.querySelectorAll('.about_timeline_desc');

        listItems.forEach(item => {
            item.addEventListener('click', () => {
                listItems.forEach(li => {
                    li.classList.remove('slick-current', 'slick-active');
                });
                item.classList.add('slick-current', 'slick-active');
                const dataId = item.getAttribute('data-id');
                contentDivs.forEach(div => {
                    div.classList.remove('active');
                });
                const activeDiv = document.getElementById(dataId);
                if (activeDiv) {
                    activeDiv.classList.add('active');
                }
            });
        });
